import getEnvironmentValue from './getEnvironmentValue';

const baseUrl = 'https://policygenius.com';

export default function blogUrl(urlFragment = '') {
  const url = getEnvironmentValue(baseUrl, 'GHOST_API_URL');

  return `${url}${urlFragment}`;
}



// WEBPACK FOOTER //
// ../src/templates/MainNav/utils/fullBlogUrl.js